import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Icon, theme } from '@navinc/base-react-components'

export const CardHeaderBack = styled(({ to, children, ...props }) => (
  <Link to={to} {...props}>
    <Icon name="actions/arrow-back" />
    {children}
  </Link>
))`
  display: flex;
  align-items: center;
  color: ${theme.neutral400};
  border-bottom: 2px solid ${theme.neutral100};
  padding-bottom: 16px;
  margin-bottom: 24px;

  > ${Icon} {
    margin-right: 8px;
  }
`
